export const sampleOutfitIds = {
  womens: {
    topsBottomsJewelryBags2ndlayer: {
      title: 'Tops Bottoms Jewelry Bags 2ndlayer',
      id: '1930140-1982385-1292600-2420729-1877067',
    },
    topsScarvesBottomsBags2ndlayer: {
      title: 'Tops Scarves Bottoms Bags 2ndlayer',
      id: '1930140-1982385-1292600-134114-2420729',
    },
    topsBottomsBagsAccessories2ndlayer: {
      title: 'Tops Bottoms Bags Accessories 2ndlayer',
      id: '1930140-1982385-1292600-2420729-2647425',
    },
    topsShortbottomsJewelryBags2ndlayer: {
      title: 'Tops Shortbottoms Jewelry Bags 2ndlayer',
      id: '1930140-1982385-1292600-1877067-2704538',
    },
    topsShortbottomsScarvesBags2ndlayer: {
      title: 'Tops Shortbottoms Scarves Bags 2ndlayer',
      id: '1930140-1982385-1292600-134114-2704538',
    },
    topsShortbottomsBagsAccessories2ndlayer: {
      title: 'Tops Shortbottoms Bags Accessories 2ndlayer',
      id: '1930140-1982385-1292600-2704538-2647425',
    },
    jewelryFootwearDressesBags: {
      title: 'Jewelry Footwear Dresses Bags',
      id: '1982385-1877067-2118279-2622825',
    },
    topsShortbottomsFootwear2ndlayer: {
      title: 'Tops Shortbottoms Footwear 2ndlayer',
      id: '1930140-1292600-2118279-2704538',
    },
    topsBottoms2ndlayerFootwear: {
      title: 'Tops Bottoms 2ndlayer Footwear',
      id: '1930140-1292600-2420729-2118279',
    },
    dresses2ndlayerBagsJewelry: {
      title: 'Dresses 2ndlayer Bags Jewelry',
      id: '1982385-1292600-1877067-2622825',
    },
    topsBottoms: {
      title: 'Tops Bottoms',
      id: '1930140-2420729',
    },
    topsShortbottoms: {
      title: 'Tops Shortbottoms',
      id: '1930140-2704538-2704538',
    },
    topsBottomsBags: {
      title: 'Tops Bottoms Bags',
      id: '1930140-1982385-2420729',
    },
    topsBottomsFootwear: {
      title: 'Tops Bottoms Footwear',
      id: '1930140-2420729-2118279',
    },
    topsBottomsJewelry: {
      title: 'Tops Bottoms Jewelry',
      id: '1930140-2420729-1877067',
    },
    topsBottomsScarves: {
      title: 'Tops Bottoms Scarves',
      id: '1930140-134114-2420729',
    },
    footwearDressesBags: {
      title: 'Footwear Dresses Bags',
      id: '1982385-2118279-2622825',
    },
    footwearDressesJewelry: {
      title: 'Footwear Dresses Jewelry',
      id: '1877067-2118279-2622825',
    },
    footwearDressesScarves: {
      title: 'Footwear Dresses Scarves',
      id: '134114-2118279-2622825',
    },
    bagsDressesJewelry: {
      title: 'Bags Dresses Jewelry',
      id: '1982385-1877067-2622825',
    },
    bagsDressesAccessories: {
      title: 'Bags Dresses Accessories',
      id: '1982385-2622825-2647425',
    },
    bagsDressesScarves: {
      title: 'Bags Dresses Scarves',
      id: '1982385-134114-2622825',
    },
    topsShortbottomsJewelryBagsFootwear: {
      title: 'Tops Shortbottoms Jewelry Bags Footwear',
      id: '1930140-1982385-1877067-2118279-2704538',
    },
    topsBottomsJewelryBagsFootwear: {
      title: 'Tops Bottoms Jewelry Bags Footwear',
      id: '1930140-1982385-2420729-1877067-2118279',
    },
  },
  mens: {
    topsShorts2ndlayerFurnishings: {
      title: 'Tops Shorts 2ndlayer Furnishings',
      id: '2407451-2773134-623980-1848803',
    },
    topsShorts2ndlayerTies: {
      title: 'Tops Shorts 2ndlayer Ties',
      id: '2407451-2773134-1848803-2757280',
    },
    topsShortsFootwearTies: {
      title: 'Tops Shorts Footwear Ties',
      id: '2407451-2489538-1848803-2757280',
    },
    footwearFurnishingsShortsTops: {
      title: 'Footwear Furnishings Shorts Tops',
      id: '2407451-623980-2489538-1848803',
    },
    bottomsFootwearTiesTops: {
      title: 'Bottoms Footwear Ties Tops',
      id: '2407451-1231226-2489538-2757280',
    },
    bottomsFootwearFurnishingsTops: {
      title: 'Bottoms Footwear Furnishings Tops',
      id: '2407451-1231226-623980-2489538',
    },
    topsShorts2ndlayerFootwear: {
      title: 'Tops Shorts 2ndlayer Footwear',
      id: '2407451-2773134-2489538-1848803',
    },
    topsBottoms2ndlayerFurnishings: {
      title: 'Tops Bottoms 2ndlayer Furnishings',
      id: '2407451-2773134-1231226-623980',
    },
    topsBottoms2ndlayerTies: {
      title: 'Tops Bottoms 2ndlayer Ties',
      id: '2407451-2773134-1231226-2757280',
    },
    topsShorts2ndlayerFootwearFurnishings: {
      title: 'Tops Shorts 2ndlayer Footwear Furnishings',
      id: '2407451-2773134-623980-2489538-1848803',
    },
    topsBottoms2ndlayerFootwear: {
      title: 'Tops Bottoms 2ndlayer Footwear',
      id: '2407451-2773134-1231226-2489538',
    },
    topsBottoms2ndlayerFootwearFurnishings: {
      title: 'Tops Bottoms 2ndlayer Footwear Furnishings',
      id: '2407451-2773134-1231226-623980-2489538',
    },
    topsFootwearBottoms: {
      title: 'Tops Footwear Bottoms',
      id: '2407451-1231226-2489538',
    },
    topsShortsFootwear: {
      title: 'Tops Shorts Footwear',
      id: '2407451-2489538-1848803',
    },
    topsBottoms: {
      title: 'Tops Bottoms',
      id: '2407451-1231226',
    },
    topsShorts2ndlayer: {
      title: 'Tops Shorts 2ndlayer',
      id: '2407451-2773134-1848803',
    },
    topsBottoms2ndlayer: {
      title: 'Tops Bottoms 2ndlayer',
      id: '2407451-2773134-1231226',
    },
    topsBottomsFurnishings: {
      title: 'Tops Bottoms Furnishings',
      id: '2407451-1231226-623980',
    },
    topsShortsFurnishings: {
      title: 'Tops Shorts Furnishings',
      id: '2407451-623980-1848803',
    },
    topsTiesBottoms: {
      title: 'Tops Ties Bottoms',
      id: '2407451-1231226-2757280',
    },
    topsShortsTies: {
      title: 'Tops Shorts Ties',
      id: '2407451-1848803-2757280',
    },
    topsShorts: {
      title: 'Tops Shorts',
      id: '2407451-1848803',
    },
  },
};
